export default "__VITE_ASSET__BmIaNx0j__"